import ConstructorVersionOne from "./versions/1/constructor.version";

export default function ConstructorComponent() {

    return ConstructorVersionOne()

}